import React, { useState, useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  CButton,
  CCard,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import MetadataCollapse from './metadataCollapse'
import { createMetaData, updateMetaData } from '../../../../Redux/Actions/metaDataAction'
import { checkPermissions } from 'src/views/utils/helper'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { GlobalContext } from 'src/views/context/GlobalState'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { isEmpty } from 'src/views/utils/helper'
import { AppContext } from 'src/views/context/app'
import { CustomDescriptionBox } from '../../../../components'

const CategoryListing = ({ categories, subCategories }) => {
  const [showModal, setShowModal] = useState(false)

  const [editFlag, setEditFlag] = useState(false)
  const [categoryId, setCategoryId] = useState('')

  const [categoryName, setCategoryName] = useState('')
  const [priority, setPriority] = useState(0)
  const [filterCategories, setFilterCategories] = useState([])
  const [description, setDescription] = useState('')
  const [orderBy, setOrderBy] = useState('modified_date')
  const [reverse, setReverse] = useState(false)
  const language = localStorage.getItem('language')
  const [errorData, setErrorData] = useState({})

  const dispatch = useDispatch()

  const { accountObj } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.META_DATA.CREATE) &&
    defaultLangCheck

  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.META_DATA.UPDATE,
  )

  useEffect(() => {
    if (isEmpty(categories)) return setFilterCategories([])
    if (categories[0].hasOwnProperty(`status`)) {
      setFilterCategories(
        categories
          .sort((ele1, ele2) => Number(ele2.status) - Number(ele1.status))
          .sort((ele1, ele2) => ele2.priority - ele1.priority),
      )
    }
  }, [categories])

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }

  const emptyState = () => {
    setCategoryName('')
    setDescription('')
    setErrorData({})
    setCategoryId('')
    setPriority(0)
    setEditFlag(false)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      categoryName: '',
    }

    if (categoryName.trim().length === 0) {
      isFormValid = false
      temp.categoryName = 'Name cannot be Empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSubmit = async () => {
    if (validateInfo()) {
      let data = {
        name: categoryName,
        type: 'category',
        description: description,
        priority,
        order_by: orderBy,
        reverse: reverse,
      }
      let res = await dispatch(createMetaData('system', data))
      if (res?.success) {
        dispatch({ type: 'REFRESH_DATA' })
        emptyState()
        setShowModal(false)
      }
    }
  }

  const handleEdit = (data) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))

    setEditFlag(true)
    setCategoryName(data.name)
    setDescription(data.description)
    setCategoryId(data._id)
    setPriority(data.priority)
    setOrderBy(data?.order_by ? data?.order_by : 'modified_date')
    setReverse(data?.reverse ? true : false)
    setShowModal(true)
  }
  const handleEditCategory = async () => {
    if (validateInfo()) {
      const data = {
        name: categoryName,
        description: description,
        priority,
        order_by: orderBy,
        reverse: reverse,
      }
      let res = await dispatch(updateMetaData('system', categoryId, data))

      if (res?.success) {
        dispatch({ type: 'REFRESH_DATA' })
        emptyState()
        setShowModal(false)
      } else {
        console.log('failed')
      }
    }
  }

  const handleAdd = () => {
    if (!createAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))

    setShowModal(true)
  }

  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase()
    setFilterCategories(categories.filter((data) => data.name.toLowerCase().search(value) !== -1))
  }

  const handleOrderBy = (value) => {
    let valueArr = value.split('-')
    setOrderBy(valueArr[0])
    setReverse(valueArr[1] === 'desc')
  }

  return (
    <div>
      <CRow>
        <CCard style={{ minHeight: '70vh' }}>
          <CRow className="mt-3 mb-3 align-items-center">
            <CFormLabel>{` Define the Content Categories you would like to have on your store`}</CFormLabel>
            <CCol>
              <CFormInput
                type="text"
                style={{ width: '18rem' }}
                placeholder="Search..."
                size="sm"
                onChange={(e) => handleSearch(e)}
              />
            </CCol>
            <CCol>
              <div className="px-2 d-md-flex justify-content-md-end">
                <CButton
                  className="text-white"
                  color="info"
                  onClick={handleAdd}
                  disabled={!createAllowed}
                  style={{ pointerEvents: 'auto' }}
                  title={defaultLangCheck ? '' : 'Adding Category Available on Default Language'}
                >
                  Add Content Category
                </CButton>
              </div>
            </CCol>
          </CRow>

          <div style={{ maxHeight: '68vh' }} className="my-2 scrollbar-class tableFixHead">
            <CTable className="">
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col" style={{ width: '5%' }}>
                    #
                  </CTableHeaderCell>
                  <CTableHeaderCell style={{ width: '23%' }} scope="col">
                    Category Name
                  </CTableHeaderCell>
                  <CTableHeaderCell style={{ width: '30%' }} scope="col">
                    Description
                  </CTableHeaderCell>
                  <CTableHeaderCell style={{ width: '10%' }} scope="col">
                    *Priority
                  </CTableHeaderCell>
                  <CTableHeaderCell style={{ width: '14%' }} scope="col">
                    Created on
                  </CTableHeaderCell>
                  <CTableHeaderCell style={{ width: '13%' }} scope="col">
                    Status
                  </CTableHeaderCell>
                  <CTableHeaderCell style={{ width: '5%' }} scope="col">
                    <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />
                  </CTableHeaderCell>
                </CTableRow>
              </CTableHead>

              <CTableBody>
                {filterCategories.map((ele, index) => (
                  <MetadataCollapse
                    key={index}
                    index={index}
                    info={ele}
                    handleEdit={handleEdit}
                    subCategoriesData={subCategories}
                  />
                ))}
              </CTableBody>
            </CTable>
          </div>
        </CCard>
        <div className="mx-1 my-2 d-flex justify-content-end">
          <p className="">
            {'*Category priority decide the order in which they are appearing in header  '}
          </p>
        </div>
      </CRow>
      <CModal size="lg" visible={showModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{editFlag ? 'Edit ' : 'Add '}Category</CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <div className="mb-">
            <CFormLabel>
              Category Name<span style={{ color: 'red' }}>*</span>
            </CFormLabel>
            <CCol lg="12">
              <CFormInput
                type="text"
                value={categoryName}
                name="categoryName"
                onChange={(e) => handleChange(e, setCategoryName)}
              />
              <div className="message-text error-message">
                <p>{errorData.categoryName}</p>
              </div>
            </CCol>
          </div>
          <div className="mt-3">
            <CustomDescriptionBox
              title="Description"
              rows={3}
              value={description}
              onChange={setDescription}
            />
            <div className="message-text error-message">
              <p>{errorData.description}</p>
            </div>
          </div>
          <div className="mb-3">
            <CFormLabel>
              Priority<span style={{ color: 'red' }}>*</span>
            </CFormLabel>
            <CCol lg="12">
              <CFormInput
                type="number"
                value={priority}
                name="priority"
                onChange={(e) => handleChange(e, setPriority)}
              />
              <div className="message-text error-message">
                <p>{errorData.priority}</p>
              </div>
            </CCol>
          </div>
          <div className="">
            <CFormLabel>
              Order By <span style={{ color: 'red' }}>*</span>
            </CFormLabel>
            <CCol lg="12">
              <CFormSelect
                value={`${orderBy}-${!reverse ? 'aesc' : 'desc'}`}
                onChange={(e) => {
                  handleOrderBy(e.target.value)
                }}
              >
                <option value={'modified_date-desc'}>Modified Date Descending</option>
                <option value={'modified_date-aesc'}>Modified Date Ascending</option>
                <option value={'created_date-desc'}>Created Date Descending</option>
                <option value={'created_date-aesc'}>Created Date Ascending</option>
                <option value={'release_time-desc'}>Release Date Descending</option>
                <option value={'release_time-aesc'}>Release Date Ascending</option>
                <option value={'title-aesc'}>Title {`(A to Z)`}</option>
                <option value={'title-desc'}>Title {`(Z to A)`}</option>
                <option value={'random-aesc'}>Random</option>
              </CFormSelect>
            </CCol>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            className="text-white"
            color="info"
            onClick={() => {
              emptyState()
              setShowModal(false)
            }}
          >
            Cancel
          </CButton>
          <CButton
            className="text-white"
            color="info"
            onClick={editFlag ? handleEditCategory : handleSubmit}
          >
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default CategoryListing
